import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import {
	ApiState,
	GetRequestPayload,
	PostRequestPayload,
	PutRequstPayload,
	RequestErrorPayload,
	RequestSuccessPayload,
} from "lib/api"

const initialState: ApiState = {
	pending: [],
	errors: {},
}

export const ApiSlice = createSlice({
	name: "api",
	initialState,
	reducers: {
		mccApiGet: (state, action: PayloadAction<GetRequestPayload>) => {
			state.pending.Append({
				requestId: action.payload.requestId,
				url: action.payload.url,
				method: "get",
				timestamp: Date.now(),
			})
		},
		mccApiPost: (state, action: PayloadAction<PostRequestPayload>) => {
			state.pending.Append({
				requestId: action.payload.requestId,
				url: action.payload.url,
				method: "post",
				timestamp: Date.now(),
			})
		},
		mccApiPut: (state, action: PayloadAction<PutRequstPayload>) => {
			state.pending.Append({
				requestId: action.payload.requestId,
				url: action.payload.url,
				method: "put",
				timestamp: Date.now(),
			})
		},
		mccApiSuccess: (state, action: PayloadAction<RequestSuccessPayload>) => {
			state.pending = state.pending.Filter(
				(req) => req.requestId !== action.payload.requestId
			)
			delete state.errors[action.payload.requestId]
		},
		mccApiError: (state, action: PayloadAction<RequestErrorPayload>) => {
			state.pending = state.pending.Filter(
				(req) => req.requestId !== action.payload.requestId
			)
			state.errors[action.payload.requestId] = action.payload.error
		},
	},
})
